import React from "react";
import PrivacyPolicyContent from "../Components/PrivacyPolicy/PrivacyPolicyContent";

const PrivacyPolicy = () => {
  return (
    <>
      <PrivacyPolicyContent />
    </>
  );
};

export default PrivacyPolicy;
